import { wrapProperty } from '@/composable/wrappers/utils';
/**
 * Gain access to the router just like using this.$router in a non-Composition API manner.
 * source: https://github.com/nuxt-community/composition-api/blob/main/src/composables/wrappers.ts
 */
export const useRouter = () => wrapProperty('$router', false);

/**
 * Returns `this.$route`, wrapped in a computed - so accessible from `.value`.
 * source: https://github.com/nuxt-community/composition-api/blob/main/src/composables/wrappers.ts
 */
export const useRoute = () => wrapProperty('$route');

/**
 * Gain access to the modal, just like using this.$modal in a non-Composition API manner.
 * source: https://github.com/nuxt-community/composition-api/blob/main/src/composables/wrappers.ts
 */
export const useModal = () => wrapProperty('$modal', false);
